import React from "react";

import { RiBilliardsFill, RiVipCrownFill } from "react-icons/ri";
import { AiTwotoneSound } from "react-icons/ai";
import { HiOutlineClipboardList } from "react-icons/hi";
import { TbPokerChip, TbMessage } from "react-icons/tb";
import {
  BsCalendar2CheckFill,
  BsCashCoin,
  BsInstagram,
  BsListCheck,
  BsTwitter,
  BsYoutube,
} from "react-icons/bs";
import { IoGameController, IoGift, IoSettings } from "react-icons/io5";
import {
  FaRegCalendarCheck,
  FaHistory,
  FaTelegramPlane,
  FaFish,
  FaChessQueen,
  FaFire,
  FaTiktok,
  FaNewspaper,
} from "react-icons/fa";
import { GiFemaleLegs } from "react-icons/gi";
import { PiSoccerBallFill } from "react-icons/pi";
import { HiShare } from "react-icons/hi";
import { RiHomeSmileFill } from "react-icons/ri";
import { BiMessageSquareAdd } from "react-icons/bi";
import { CgFacebook } from "react-icons/cg";
import { MdCasino, MdSportsBasketball } from "react-icons/md";

const iconStyle = "text-2xl mr-[10px]";

export const COMMON_ALT = "911win Giải trí trực tuyến";
export const COMMON_LOADING = 1500;
export const COMMON_WEB_PATH = "https://911win.s3.ap-southeast-1.amazonaws.com";
export const WEB_PATH = "https://new911viet.91url.cc/casino/";
export const API_WEB_PATH = "https://new911viet.91url.cc";
export const WEB = "https://new911viet.91url.cc/";
export const LOTTERY_LINK = "https://888xoso.net/";
export const BACK_DASHBOARD = "https://ams2.911win.co/";
export const ROULETTE_PATH = "https://roulette.911win.co/";

export const API_RELOAD = 50000;
export const DEPOSIT_AMOUNT_MIN = 10000;
export const WITHDRAW_AMOUNT_MIN = 600000;
export const BALANCE_RELOAD = 10000;

export const COMMON_FIXED_STYLE =
  "fixed top-0 left-0 w-full h-full overflow-scroll no-scrollbar z-[9999]";

export const CURRENCY_SYMBOL = "₫";

export const MENU_LIST = {
  Home: [
    {
      icon: <RiHomeSmileFill className={iconStyle} />,
      text: "Home",
      link: "/",
      header: true,
    },
    {
      icon: <FaFire className={iconStyle} />,
      text: "Slot",
      link: "/slot",
      header: true,
    },
    {
      icon: <MdCasino className={iconStyle} />,
      text: "Live",
      link: "/live",
      header: true,
    },
    {
      icon: <FaFish className={iconStyle} />,
      text: "Fish",
      link: "/fish",
      header: true,
    },
    {
      icon: <IoGameController className={iconStyle} />,
      text: "Egame",
      link: "/egame",
      header: true,
    },
    {
      icon: <FaChessQueen className={iconStyle} />,
      text: "RNG",
      link: "/rng",
      header: true,
    },
    {
      icon: <MdSportsBasketball className={iconStyle} />,
      text: "Sports",
      link: "/sports",
      header: true,
    },
  ],
  AllPlatform: [
    {
      icon: <RiHomeSmileFill className={iconStyle} />,
      text: "AllPlatform",
      link: "AllPlatform",
      header: true,
    },
  ],
  First: [
    {
      icon: <BsCashCoin className={iconStyle} />,
      text: "Transaction",
      link: "/profile/transaction",
    },
    {
      icon: <AiTwotoneSound className={iconStyle} />,
      text: "Promotions",
      link: "/promotion",
    },
    {
      icon: <TbMessage className={iconStyle} />,
      text: "Inbox",
      link: "/profile/inbox",
    },
    // {
    //   icon: <AiOutlineTransaction className={iconStyle} />,
    //   text: "Point Exchange",
    //   link: "pointexchange",
    // },
    // {
    //   icon: <HiOutlineClipboardList className={iconStyle} />,
    //   text: "Todo",
    //   link: "todo",
    // },
  ],
  Second: [
    {
      icon: <IoGift className={iconStyle} />,
      text: "Rewards",
      link: "/profile/rewards",
    },
    {
      icon: <BsListCheck className={iconStyle} />,
      text: "Task",
      link: "/task",
    },
    {
      icon: <BsCalendar2CheckFill className={iconStyle} />,
      text: "checkin",
      link: "checkin",
    },
    {
      icon: <TbPokerChip className={iconStyle} />,
      text: "Roulette",
      link: "roulette",
    },

    {
      icon: <HiShare className={iconStyle} />,
      text: "Refer-Code",
      link: "/profile/refer-code",
    },
  ],
  Third: [
    {
      icon: <IoSettings className={iconStyle} />,
      text: "Settings",
      link: "/profile/settings",
    },

    {
      icon: <BiMessageSquareAdd className={iconStyle} />,
      text: "App",
      link: "app",
    },
  ],
};

export const DEPOSIT_AMOUNT = [
  { amount: 100000 },
  { amount: 200000 },
  { amount: 500000 },
  { amount: 1000000 },
  { amount: 2000000 },
  { amount: 5000000 },
];

export const VIP_LIST = [
  { prize: 0, exp: 0 },
  { prize: 3, exp: 800 },
  { prize: 10, exp: 4000 },
  { prize: 20, exp: 10000 },
  { prize: 50, exp: 20000 },
  { prize: 100, exp: 40000 },
  { prize: 200, exp: 80000 },
  { prize: 500, exp: 160000 },
  { prize: 1000, exp: 320000 },
  { prize: 2000, exp: 640000 },
  { prize: 5000, exp: 1280000 },
  { prize: 10000, exp: 2560000 },
  { prize: 20000, exp: 5120000 },
  { prize: 50000, exp: 10240000 },
  { prize: 100000, exp: 20480000 },
];

export const DAILY_REWARDS = [
  "Seven-day login bonus",
  "Conditions for each day of login:",
  "Day 1: Log in to the platform to receive the bonus.",
  "Day 2: Place accumulated bets of 10 BRL to receive the bonus.",
  "Day 3: Log in to the platform to receive the bonus.",
  "Day 4: Make a top-up of any amount to receive the bonus.",
  "Day 5: Log in to the platform to receive the bonus.",
  "Day 6: Place accumulated bets of 20 BRL to receive the bonus.",
  "Day 7: Redeem the reward upon logging into the platform on the day, win up to 100 BRL and deposit bonus items.",
  "Bet the login bonus 10 times to make a withdrawal.",
];

export const BANK_LIST = ["Unionbank", "GCash", "BDO", "BPI", "Metrobank"];

export const MEDIA_LINK = [
  {
    icon: <CgFacebook className={iconStyle} />,
    link: "https://www.facebook.com/911win911",
  },
  {
    icon: <BsYoutube className={iconStyle} />,
    link: "https://www.youtube.com/@911win9",
  },
  {
    icon: <FaTiktok className={iconStyle} />,
    link: "https://www.tiktok.com/@giitr911wingameon",
  },
  {
    icon: <BsInstagram className={iconStyle} />,
    link: "https://www.instagram.com/911win_viet/",
  },
  {
    icon: <BsTwitter className={iconStyle} />,
    link: "https://twitter.com/911winCo",
  },
];

export const COLLECTION_LINK = [
  {
    icon: <FaNewspaper className={iconStyle} />,
    link: "https://911win.club/",
    title: "News",
  },
  {
    icon: <PiSoccerBallFill className={iconStyle} />,
    link: "https://911fifa.com/",
    title: "Sports",
  },
  {
    icon: <GiFemaleLegs className={iconStyle} />,
    link: "http://live33.live/",
    title: "live33",
  },
  {
    icon: <RiBilliardsFill className={iconStyle} />,
    link: "https://888xoso.net/",
    title: "Vietnam lottery results",
  },
];

export const termList = [
  { label: "About Us", link: "/about", forSub: "about" },
  { label: "Private", link: "/private", forSub: "private" },
  {
    label: "Responsibility",
    link: "/responsibility",
    forSub: "responsibility",
  },
  { label: "Service", link: "/service", forSub: "service" },
  { label: "FAQ", link: "/faq", forSub: "faq" },
  {
    label: "Deposit or Withdraw",
    link: "/deposit-withdraw",
    forSub: "deposit-withdraw",
  },
  { label: "How To Play", link: "/how-to-play", forSub: "how-to-play" },
  {
    label: "Friend Recommend",
    link: "/friend-recommend",
    forSub: "friend-recommend",
  },
];
